import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import About from '../views/AboutMe.vue';
import StartDonate from '../views/StartDonate.vue';
import DonatePage from '../views/DonatePage.vue';
import AboutCampaign from '../views/AboutCampaign.vue';
import DonorsPage from '../views/DonorsPage.vue';
import Thanks from '../views/ThanksPage.vue';
import Howto from '../views/HowtoPage.vue';
import InAppPage from "../views/InAppPage.vue";

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/about', name: 'about', component: About },
  { path: '/start-donate', name: 'start-donate', component: StartDonate },
  { path: '/start-donate/:id', name: 'StartDonateByID', component: StartDonate },
    { path: '/donate', name: 'DonatePage', component: DonatePage },
  { path: '/donate/:id', name: 'DonatePageByID', component: DonatePage },
  { path: '/donors', name: 'DonorsPage', component: DonorsPage },
  { path: '/about-campaign/:id', name: 'AboutCampaign', component: AboutCampaign },
  { path: '/thank-you', name: 'Thanks', component: Thanks },
  { path: '/how-to', name: 'Howto', component: Howto },
  { path: '/In-App-browser', name: 'InAppBrowser', component: InAppPage },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/views/NotFound.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
